import React from 'react';
import useTimeoutVisability from '@utils/hooks/useTimeoutVisability';

interface SpinnerProps {
    height?: string;
    width?: string;
    timeout?: number;
}

const SmallSpinnerTimeout = ({ 
    height = '16px', 
    width = '16px',
    timeout = 5000
}: SpinnerProps) => {
    const { isVisible } = useTimeoutVisability({ 
        timeout,
        dependencies: [] // No dependencies for spinner timeout
    });

    if (!isVisible) {
        return (
            <span className={`w-[${width}] h-[${height}]`}>
            </span>
        );
    }

    return (
        <div className={`max-w-[${width}] max-h-[${height}] min-w-[${width}] min-h-[${height}] flex justify-center items-center`}>
            <div
                className={`flex justify-center items-center loader w-[14px] h-[14px] border-2 border-gray-200 border-t-2 border-t-success110 dark:border-t-success090 rounded-full animate-spin`}
            ></div>
        </div>
    )
};

export default SmallSpinnerTimeout;
